import ResultsInterface from '@Services/ResultsInterface';
import { withGlobalSpinnerActionEnhancer } from '@Utils/Redux/withGlobalSpinnerActionEnhancer';
import { showDialogZeroResults } from '@Containers/FindPreparations/utils';
import findPreparationsService from '@Containers/FindPreparations/FindPreparationsService';
import { closeFindPreparationsSimilaritySearchDialog } from './dialogActions';
import {
  CLEAN_STATE,
  LOAD_SIMILARITY_SEARCH_RESULTS,
  LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE,
  LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS,
  SIMILARITY_SEARCH,
  SIMILARITY_SEARCH_FAILURE,
  SIMILARITY_SEARCH_SUCCESS,
} from './constants';
import { resultPayload as resultPayloadSelector, reactions as reactionsSelector, totalItems as totalItemsSelector } from './selectors';
import { getResultSet } from './SimilaritySearchService';

const LOAD_MORE_COUNT = 9;

export const fetchSimilaritySearch = ({ substance, originalDatabaseId }) => {
  return async (dispatch) => {
    dispatch({ type: SIMILARITY_SEARCH });
    try {
      const result = await getResultSet({ substance, databaseId: originalDatabaseId });
      const { resultName, context, resultSize, databaseId, goalSubstanceMolImage } = result;
      const resultPayload = {
        databaseId,
        resultName,
        context,
        firstItem: 1,
        lastItem: 10,
        similarityMol: goalSubstanceMolImage.structure,
        forPlanner: true,
        sort: 'SIMILARITY',
        order: 'desc',
      };

      dispatch({
        type: SIMILARITY_SEARCH_SUCCESS,
        resultPayload,
        totalItems: resultSize,
      });
    } catch (e) {
      dispatch({
        type: SIMILARITY_SEARCH_FAILURE,
        payload: e,
      });
      await dispatch(closeFindPreparationsSimilaritySearchDialog());
      showDialogZeroResults();
    }
  };
};

export const loadSimilaritySearchResults = () => {
  return async (dispatch, getState) => {
    dispatch({ type: LOAD_SIMILARITY_SEARCH_RESULTS });

    const state = getState();
    const resultPayload = resultPayloadSelector(state);
    const reactions = reactionsSelector(state);
    const totalItems = totalItemsSelector(state);

    if (!resultPayload) return;

    const firstItem = (reactions && reactions.length) || 1;
    const lastItem = firstItem + LOAD_MORE_COUNT < totalItems ? firstItem + LOAD_MORE_COUNT : totalItems;

    const payload = {
      ...resultPayload,
      firstItem,
      lastItem,
    };

    ResultsInterface.getResults(payload).subscribe({
      next: ({ data }) => {
        dispatch({
          type: LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS,
          searchResult: data,
        });
      },
      error: (error) => {
        dispatch({
          type: LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE,
          payload: error,
        });
      },
    });
  };
};

export const cleanState = () => ({ type: CLEAN_STATE });

export const submitSimilarSubstance = withGlobalSpinnerActionEnhancer(({ substance, databaseId, context }) => {
  return async () => {
    try {
      await findPreparationsService.goToSynthesisPreparations(substance, databaseId, context, true);
    } catch (error) {
      Logger.error(error);
    }
  };
});
